var exports = {
  "kL": "FriendsSkeleton.module__container___XzhOSG",
  "Em": "FriendsSkeleton.module__mainColumn___XzhOSG",
  "wx": "FriendsSkeleton.module__header___XzhOSG",
  "BS": "FriendsSkeleton.module__headerLeftSection___XzhOSG",
  "Gv": "FriendsSkeleton.module__backButton___XzhOSG",
  "cZ": "FriendsSkeleton.module__backButtonMobile___XzhOSG",
  "LD": "FriendsSkeleton.module__headerLeft___XzhOSG",
  "cP": "FriendsSkeleton.module__titleSection___XzhOSG",
  "yF": "FriendsSkeleton.module__divider___XzhOSG",
  "me": "FriendsSkeleton.module__tabsWrapper___XzhOSG",
  "VD": "FriendsSkeleton.module__tabsInner___XzhOSG",
  "IE": "FriendsSkeleton.module__headerRight___XzhOSG",
  "Qs": "FriendsSkeleton.module__content___XzhOSG",
  "sf": "FriendsSkeleton.module__searchWrapper___XzhOSG",
  "MJ": "FriendsSkeleton.module__tabBody___XzhOSG",
  "p_": "FriendsSkeleton.module__list___XzhOSG",
  "p$": "FriendsSkeleton.module__emptyState___XzhOSG",
  "AI": "FriendsSkeleton.module__emptyStateIcon___XzhOSG",
  "vo": "FriendsSkeleton.module__emptyStateTitle___XzhOSG",
  "F9": "FriendsSkeleton.module__emptyStateSubtitle___XzhOSG",
  "Gf": "FriendsSkeleton.module__sectionTitle___XzhOSG" + " " + __webpack_require__(530449)["Gf"],
  "Ge": "FriendsSkeleton.module__rows___XzhOSG" + " " + __webpack_require__(530449)["f5"],
  "GF": "FriendsSkeleton.module__rowsWithMargin___XzhOSG" + " " + __webpack_require__(530449)["v2"],
  "nM": "FriendsSkeleton.module__row___XzhOSG",
  "z2": "FriendsSkeleton.module__rowInfo___XzhOSG",
  "pt": "FriendsSkeleton.module__rowDetails___XzhOSG",
  "hj": "FriendsSkeleton.module__rowNameBand___XzhOSG",
  "f": "FriendsSkeleton.module__rowSubtextBand___XzhOSG",
  "cm": "FriendsSkeleton.module__rowActions___XzhOSG",
  "pz": "FriendsSkeleton.module__sidebar___XzhOSG",
  "aN": "FriendsSkeleton.module__sidebarHeader___XzhOSG",
  "wp": "FriendsSkeleton.module__sidebarContent___XzhOSG",
  "rF": "FriendsSkeleton.module__sidebarEmptyState___XzhOSG",
  "sM": "FriendsSkeleton.module__sidebarEmptyTitle___XzhOSG",
  "iZ": "FriendsSkeleton.module__sidebarEmptyDescription___XzhOSG",
  "KC": "FriendsSkeleton.module__sidebarEmptyDescriptionLine___XzhOSG",
  "H4": "FriendsSkeleton.module__activeNowCard___XzhOSG",
  "zO": "FriendsSkeleton.module__activeNowContextGroup___XzhOSG",
  "vA": "FriendsSkeleton.module__activeNowStatus___XzhOSG",
  "Ud": "FriendsSkeleton.module__activeNowContext___XzhOSG",
  "dr": "FriendsSkeleton.module__activeNowParticipants___XzhOSG",
  "$Q": "FriendsSkeleton.module__activeNowAction___XzhOSG",
};

module.exports = exports;
